import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const Auth = () => {
  const navigate = useNavigate();
  const [searchParams, setsearchParams] = useSearchParams();
  const token = searchParams.get("token");

  const origin = searchParams.get("origin");
  console.log("🚀 ~ Auth ~ origin:", origin);
  useEffect(() => {
    if (token !== null && token !== "") {
      localStorage.clear()
      localStorage.setItem("origin", "internal");
      localStorage.setItem("token", token);
      return navigate("/user/findcontact");
    }
  });
  return (
    <div>
      <></>
    </div>
  );
};

export default Auth;
